export {default as Example} from './modules/Example';
export {default as Load} from './modules/Load';
export {default as Scroll} from './modules/Scroll';
export {default as Page} from './modules/Page';
export {default as Video} from './modules/Video';
export {default as HomeHero} from './modules/HomeHero';
export {default as Hero} from './modules/Hero';
export {default as Popins} from './modules/Popins';
export {default as Menus} from './modules/Menus';
export {default as Nav} from './modules/Nav';
export {default as Story} from './modules/Story';
export {default as Services} from './modules/Services';
export {default as Collapse} from './modules/Collapse';
export {default as FooterCarousel} from './modules/FooterCarousel';
export {default as Shape} from './modules/Shape';
export {default as Slider} from './modules/Slider';
export {default as Alert} from './modules/Alert';
